<template>
  <div class="upload-container">
    <div class="upload-img" @click="xiumiClick">
      <img src="https://new-shengxue985-test.oss-cn-hangzhou.aliyuncs.com/sxzx/2021/3/pic/b51d89be78954dfdafef3436d6fb28fe.png" alt="">
    </div>
    <el-button
      class="upload-btn"
      icon='el-icon-upload'
      size="mini"
      :style="{background:color,borderColor:color}"
      @click=" dialogVisible=true"
      type="primary"
    >上传图片
    </el-button>
    <el-dialog
      title="上传图片"
      width="568px"
      append-to-body
      :visible.sync="dialogVisible"
    >
      <el-upload
        class="editor-slide-upload"
        :action="uploadUrl"
        :headers="headers"
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        list-type="picture-card"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
      >
        <el-button
          size="small"
          type="primary"
        >点击上传</el-button>
      </el-upload>
      <div class="btn-footer">
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="1600px"
      top="2vh"
      :visible.sync="dialogxiumi"
    >
    <iframe src="https://xiumi.us/studio/v5#/paper/for/new/cube/0" width="100%" height="800" frameborder="0" scrolling="auto" id="iframename" name="iframename"></iframe>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from "@/utils/auth";
export default {
  name: "editorSlideUpload",
  props: {
    color: {
      type: String,
      default: "#1890ff"
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogxiumi:false,
      listObj: {},
      fileList: [],
      // uploadUrl: process.env.BASE_API + "/file/uploadPic",
      uploadUrl: process.env.NPI_API + "/admin/upload/uploadOssFile?admin_id=" + this.$store.getters.userId,
      headers: {
        Authorization: ''
      }
    };
  },
  methods: {
    xiumiClick(){
      this.dialogxiumi = true;
    },
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        item => this.listObj[item].hasSuccess
      );
    },
    handleSubmit() {
      const arr = Object.keys(this.listObj).map(v => this.listObj[v]);
      console.log(Object.keys(this.listObj));
      console.log(arr);
      if (!this.checkAllSuccess()) {
        this.$message(
          "请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！"
        );
        return;
      }
      this.$emit("successCBK", arr);
      this.listObj = {};
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleSuccess(response, file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = response.data;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    },
    beforeUpload(file) {
      const _self = this;
      const _URL = window.URL || window.webkitURL;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          _self.listObj[fileName] = {
            hasSuccess: false,
            uid: file.uid,
            width: this.width,
            height: this.height
          };
        };
        resolve(true);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.upload-container .editor-slide-upload {
  margin-bottom: 20px;
}
.upload-img{
  float: left;
  padding-top: 5px;
  display: none;
}
.el-upload{
  margin: 0 auto;
}
/deep/ .el-dialog__body{
  text-align: center;
}
.btn-footer {
  margin-top: 30px;
  text-align: right;
}
</style>
